<div class="steps-container min-h-screen">
    <div class="header">
        <div class="logo-container">
            <img
                    class="logo"
                    src="assets/logo-icon.svg"
                    alt="logo"
                    [routerLink]="['/login']"
            />
            <div class="logo-text">
                <h2>WELL DONE</h2>
            </div>
            <div class="regType">
                <h1>{{ getRegistrationValue() }}</h1>
            </div>
        </div>
    </div>



    <div class="steps">

        <ng-container *ngFor="let step of steps; let i = index">

            <div
                    class="step"
                    [ngClass]="{
          'active': step.id <= currentStep,
          'current': step.id === currentStep
        }"
            >
                <div class="step-icon">
                    {{ step.id }}
                </div>

                <div class="step-text">
                    <h3 class="step-title">
                        {{ step.title }}
                    </h3>

                    <span class="step-description">
            {{ step.text }}
          </span>
                </div>
            </div>

            <div
                    class="step-line"
                    *ngIf="i + 1 !== steps.length"
            ></div>

        </ng-container>

        <div class="sidebar-footer">
            <button
                    *ngIf="typeOfRegistration === 'company'"
                    type="button"
                    class="onboarding-logout"
                    (click)="exitOnboarding.emit()"
            >
                <i class="bi bi-box-arrow-left" aria-hidden="true"></i>
                <span>Esci dall'onboarding</span>
            </button>

            <div class="mailto-container">
                <a href="mailto:support@welldone.com">
                    support@welldone.com
                </a>
            </div>
        </div>

    </div>
</div>
